export default __webpack_public_path__ + "static/media/hf2.1d8b5bd6.svg";